window.toaster = function()
{
    const overlay = $('.overlay-default');

    /**
     * Click event to open toaster
     */
    $('a[data-toaster]').on('click', function(e)
    {
        e.preventDefault();
        openToaster($(this).data('toaster'));
    });

    /**
     * Click even to close toaster
     */
    $('.toaster-close').on('click', closeToaster)

    /**
     * Mouseup event outside toaster to close it
     */
    $(document).on('mouseup',function(e)
    {
        let toaster = $('.toaster');

        if(toaster.data('closable')) {
            if (!toaster.is(e.target) && toaster.has(e.target).length === 0) {
                closeToaster();
            }
        }
    });

    function openToaster(toasterReference)
    {
        $('.toaster').removeClass('active');
        $(`.toaster.toaster-${toasterReference}`).addClass('active');
        overlay.show();
    }

    function closeToaster()
    {
        if($('.toaster').length > 0) {
            overlay.hide();
        }

        $('.toaster').removeClass('active');
    }
}

toaster();
